/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  DeleteMailTemplateResponseData,
  DeleteMailTemplateResponseDataFromJSON,
  DeleteMailTemplateResponseDataFromJSONTyped,
  DeleteMailTemplateResponseDataToJSON
} from './DeleteMailTemplateResponseData'

/**
 *
 * @export
 * @interface DeleteMailTemplateResponse
 */
export interface DeleteMailTemplateResponse {
  /**
   *
   * @type {number}
   * @memberof DeleteMailTemplateResponse
   */
  status?: number
  /**
   *
   * @type {DeleteMailTemplateResponseData}
   * @memberof DeleteMailTemplateResponse
   */
  data?: DeleteMailTemplateResponseData
}

export function DeleteMailTemplateResponseFromJSON(json: any): DeleteMailTemplateResponse {
  return DeleteMailTemplateResponseFromJSONTyped(json, false)
}

export function DeleteMailTemplateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteMailTemplateResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : DeleteMailTemplateResponseDataFromJSON(json['data'])
  }
}

export function DeleteMailTemplateResponseToJSON(value?: DeleteMailTemplateResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: DeleteMailTemplateResponseDataToJSON(value.data)
  }
}
